import request from "@/plugins/request";

// 获取单个索赔信息
export function claimWarrantyInfo(id, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/claimWarranty/${id}`,
		method: "get",
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取单个索赔信息
export function processInfo(id, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/claimWarranty/process/${id}`,
		method: "get",
		headers: {
			showLoading: showLoading,
		},
	});
}

// 索赔申请列表
export function claimApplyList(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/getDataApplyList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 索赔审核列表
export function claimReviewList(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/getDataAuditList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 索赔发货列表
export function claimDeliveryList(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/getDataShippingList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取单个订购信息
export function claimOrdersInfo(id, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/claimOrders/${id}`,
		method: "get",
		headers: {
			showLoading: showLoading,
		},
	});
}

// 订购零件新增
export function addClaimOrders(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/addClaimOrders`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 订单科审核拒绝/回退
export function claimOrdersAuditAdd(params, showLoading = false) {
	return request({
		url: `bsi/sysAudit/claimOrdersAudit/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 订单科审核通过
export function claimOrdersAuditPass(params, showLoading = false) {
	return request({
		url: `parts/partsClaimOrders/innerPass`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 故障件发货1
export function claimWarrantyDeliveryFault(params, showLoading = false) {
	return request({
		url: `parts/partsClaimWarranty/deliveryFault`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 故障件发货2
export function claimOrdersDeliveryFault(params, showLoading = false) {
	return request({
		url: `parts/partsClaimOrders/deliveryFault`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 故障件发货3
export function claimMaterialDeliveryFault(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMaterial/deliveryFault`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 机器零件新增
export function partsClaimDetailAdd(params, showLoading = false) {
	return request({
		url: `parts/partsClaimDetail/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 机器零件编辑
export function partsClaimDetailUpdate(params, showLoading = false) {
	return request({
		url: `parts/partsClaimDetail/update`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 订购零件实物审批暂存/提交
export function updateOrders(params, showLoading = false) {
	return request({
		url: `parts/partsClaimOrders/updateOrders`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 服务部测试提交
export function testSubmit(params, showLoading = false) {
	return request({
		url: `parts/partsClaimOrders/testSubmit`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 单个零件-测试件退回
export function testReturn(params, showLoading = false) {
	return request({
		url: `parts/partsClaimDetail/testReturn`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 商品耗材新增
export function addClaimMaterial(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/addClaimMaterial`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 商品耗材编辑
export function updateClaimMaterial(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/updateClaimMaterial`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取单个商品耗材信息
export function claimMaterialInfo(id, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/claimMaterial/${id}`,
		method: "get",
		headers: {
			showLoading: showLoading,
		},
	});
}

// 获取单个商品耗材信息
export function claimMaterialProcessInfo(id, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/claimMaterial/process/${id}`,
		method: "get",
		headers: {
			showLoading: showLoading,
		},
	});
}

// 服务部审核拒绝/回退
export function claimMateriaAuditAdd(params, showLoading = false) {
	return request({
		url: `bsi/sysAudit/claimMaterialAudit/add`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 服务部审核通过
export function claimMateriaAuditPass(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMaterial/innerPass`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 商品耗材实物审批暂存/提交
export function updateMaterial(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMaterial/updateMaterial`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 判断是否存在未结束的资料后补
export function judgeAdditional(params, showLoading = false) {
	return request({
		url: `parts/partsClaimWarranty/judgeAdditional`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 根据机号 查询延保信息
export function getByRepairDeviceNumber(params, showLoading = false) {
	return request({
		url: `parts/partsWarrantyInfo/getByRepairDeviceNumber`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 下载退换机申请书
export function exportExchangeFile(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMaterial/exportExchangeFile`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}

// 索赔申请导出
export function dataApplyExport(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/dataApplyExport`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 资料审核导出
export function dataAuditExport(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/dataAuditExport`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 索赔发货导出
export function dataShippingExport(params, showLoading = false) {
	return request({
		url: `parts/partsClaimMain/dataShippingExport`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 索赔零件
export function claimPartsList(params, showLoading = false) {
	return request({
		url: `parts/partsClaimDetail/pageList`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
// 索赔发货导出
export function dataPartsExport(params, showLoading = false) {
	return request({
		url: `parts/partsClaimDetail/export`,
		method: "post",
		data: params,
		headers: {
			showLoading: showLoading,
		},
	});
}
